import _ from "lodash"

const getRepresentmentData = ({ data, path }:{ data:any; path:string }) => {
  if( path.startsWith("rp.") ){ path = path.split("rp.")[1] }
  return _.get(data, path)
}

const getMerchantData = ({ data, path }:{ data:any; path:string }) => {
  if( path.startsWith("merchant.") ){ path = path.split("merchant.")[1] }
  if( path.startsWith("merch.") ){ path = path.split("merch.")[1] }
  const result = _.get(data, path)
  return result
}

export const getFromRp = (apidata:any, path:string) => getRepresentmentData({ data: apidata.rp, path })
export const getFromMerch = (apidata:any, path:string) => getMerchantData({ data: apidata.merchant, path })
export const getApiFeedData = (apidata:any, path:string) => (path.startsWith("rp.")) ? getFromRp(apidata, path) : getFromMerch(apidata, path)